import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Routable::PublicPost @model={{this.model}} />",{ moduleName: "mewe/templates/public-post.hbs" })